export default __webpack_public_path__ + "static/media/vezarat-sanat-madan-t.12fcbfeb.png";